import gsap from '../ge9x/gsap.min.js';
import { ScrollTrigger } from '../ge9x/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

ScrollTrigger.defaults({
  // Defaults are used by all ScrollTriggers
  //events: onEnter onLeave onEnterBack onLeaveBack
  toggleActions: "restart pause resume pause",
  //options: play, pause, resume, reset, restart, complete, reverse,none
  // markers: true // Easily remove markers for production
});

// **************************************************
// media container masking animation
if (document.querySelector(".video-mask-container")) {
  gsap.from('.video-mask-container', {
    clipPath: "inset(10% 3% 0%)", duration: 2,   ease: "yes",
    transition: "all .3s ease",
    scrollTrigger: {
      trigger: ".story-video-scroll", // What element triggers the scroll
      scrub: true,
      start: "top 10%",
      end: "+=40%",
    }
  });
}

const storyVideoScroll = document.querySelectorAll(".story-video-scroll");

if (storyVideoScroll.length) {
  window.addEventListener("scroll", () => {
    storyVideoScroll.forEach((elem) => {
      let scrollContainer = elem.querySelector(".banner-scroll-text-container").offsetHeight;
      let videoStickyContainer = elem.querySelector(".video-sticky-container");
      let videoStickyContainerHeight = elem.querySelector(".video-container").getBoundingClientRect().height;
      let scrollTop = window.pageYOffset;
      let scrollFromTop = scrollTop + elem.getBoundingClientRect().top;
      let scrollTransitionHeight = elem.offsetHeight;
      let storyContainer = elem.querySelector(".custom-padding");
      let scrollTextLight = elem.querySelector(".banner-text-container");
      let scrollTextLightMain = elem.querySelector(".banner-scroll-text-container");
      let textContTop = scrollTextLight.offsetTop;
      let scrollTransitionTop = elem.getBoundingClientRect().top + 200;
      let scrollP = 800;

      let scrollItemIndex = 0;
      const scrollElements = elem.querySelectorAll(".banner-scroll-text");
      videoStickyContainer.style.height = `${(videoStickyContainerHeight + scrollContainer) * 2 }px`;

      // for Macbook Safari fixes
      let platform = navigator.userAgent;
      if (platform.indexOf("Mac") != -1) {
        scrollP = 1000;
        videoStickyContainer.style.height = `${(videoStickyContainerHeight + scrollContainer) * 2.5}px`;
      }

      if (window.innerWidth >= 768) {
        if (scrollTop > scrollFromTop - scrollTransitionHeight / 100) {
          scrollTextLight.style.opacity = 1;
          scrollTextLightMain.style.opacity = 1;
          scrollTextLight.style.transition = `opacity 1s ease-in-out`;
          scrollTextLightMain.style.transition = `top 0.9s ease, opacity 1s ease`;
        } else if (scrollTop > scrollFromTop - (scrollTransitionHeight / 100) * 10) {
          scrollTextLight.style.opacity = 0.3;
          scrollTextLightMain.style.opacity = 0.3;
        } else {
          scrollTextLight.style.opacity = 0;
          scrollTextLightMain.style.opacity = 0;
        }
      } else {
        storyContainer.style.clipPath = `inset(0)`;
        scrollTextLight.style.opacity = 1;
        scrollTextLightMain.style.opacity = 1;
      }

      scrollElements.forEach((el, ind, elems) => {
        if (window.innerWidth >= 768) {
          if (scrollTransitionTop + scrollP * scrollItemIndex < 0) {
            scrollItemIndex++;
            el.parentElement.style.top = `${textContTop - el.offsetTop - 16}px`;
            if (!el.nextElementSibling) {
              elems[elems.length - 1].style.visibility = "visible";
              elems[elems.length - 1].classList.add("fade-in");
              el.style.opacity = 1;
            }
            if (el.nextElementSibling) {
              el.nextElementSibling.style.visibility = "visible";
              el.nextElementSibling.style.opacity = 0.3;
              el.nextElementSibling.classList.add("fade-out");
              el.style.opacity = 1;
            }
            if (el.previousElementSibling) {
              el.previousElementSibling.classList.add("fade-in");
              el.previousElementSibling.style.opacity = 0;
            }
          } else {
            el.style.visibility = "hidden";
            el.classList.remove("fade-in");
            el.classList.remove("fade-out");
            elems[0].classList.add("first-fade-out");
            if (el.previousElementSibling) {
              el.previousElementSibling.classList.remove("fade-in");
            }
            elems[scrollItemIndex].style.visibility = "visible";
          }
        } else {
          if (scrollTransitionTop + scrollP * scrollItemIndex < 0) {
            scrollItemIndex++;
            if (!el.nextElementSibling) {
              elems[elems.length - 1].style.opacity = 1;
              el.style.opacity = 1;
              elems[elems.length - 1].style.transform = "translateY(1rem)";
              el.style.transform = "translateY(-1rem)";
            }

            if (el.nextElementSibling) {
              el.nextElementSibling.style.opacity = 0;
              el.style.opacity = 0;
              el.nextElementSibling.style.transform = "translateY(0)";
              el.style.transform = "translateY(0)";
            }

            if (el.previousElementSibling) {
              el.previousElementSibling.style.opacity = 0;
              el.previousElementSibling.style.transform = "translateY(0)";
            }
          } else {
            el.style.opacity = 0;
            elems[scrollItemIndex].style.opacity = 1;
            el.style.transform = "translateY(0)";
            elems[scrollItemIndex].style.transform = "translateY(-1rem)";
          }
        }
      });
    });
  });
}
